import PropertyMaintenanceContainer from 'app/sm/property_maintenance/property_maintenance_container'

export default PropertyMaintenanceContainer
